import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartRemove = ({ item }) => {
  const { removeLineItem } = useCartContext();

  return (
    <button
      class="type-overline button button--link uppercase underline"
      aria-label={getTranslation('cart.remove_item')}
      type="button"
      onClick={() => removeLineItem(item.id)}
    >
      <svg
        class="h-5 w-5 stroke-coral"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title> {getTranslation('cart.remove')} </title>
        <path
          d="M6.33301 8.16667V13.1667M9.66634 8.16667V13.1667M1.33301 4.83333H14.6663M13.833 4.83333L13.1105 14.9517C13.0806 15.3722 12.8924 15.7657 12.5839 16.053C12.2755 16.3403 11.8696 16.5 11.448 16.5H4.55134C4.12979 16.5 3.7239 16.3403 3.41541 16.053C3.10693 15.7657 2.91877 15.3722 2.88884 14.9517L2.16634 4.83333H13.833ZM10.4997 4.83333V2.33333C10.4997 2.11232 10.4119 1.90036 10.2556 1.74408C10.0993 1.5878 9.88735 1.5 9.66634 1.5H6.33301C6.11199 1.5 5.90003 1.5878 5.74375 1.74408C5.58747 1.90036 5.49967 2.11232 5.49967 2.33333V4.83333H10.4997Z"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  );
};

export default CartRemove;
